export default __webpack_public_path__ + "static/media/top-banner.f7db9fdc.jpg";